import * as SiteManager from '../domain/site-manager';
import React, { createContext, useContext } from 'react';
import { useData, dataFromDataset } from './DataProviderCache';
import { useAuthHelper } from '../../components/AuthContextProvider';
import { Data } from '../../types/data-providers';

type ContextState = Data<number | null>;

const Context = createContext<ContextState | null>(null);

function useDeviceCount(): ContextState {
    const contextState = useContext(Context);
    if (contextState === null) {
        throw new Error('useDeviceCount must be used within a DeviceCountProvider');
    }
    return contextState;
}

const DeviceCountProvider: React.FC<{ siteId: string }> = (props) => {
    const authHelper = useAuthHelper();
    const { dataset } = useData({
        cacheKey: 'device-count-data',
        id: props.siteId,
        dataFn: React.useCallback(() => SiteManager.getDeviceCount(authHelper, { siteId: props.siteId }), [
            authHelper,
            props.siteId,
        ]),
    });
    const deviceCount = dataFromDataset(dataset);

    return <Context.Provider value={deviceCount}>{props.children}</Context.Provider>;
};

const TestDeviceCountDataProvider: React.FC<{ value: ContextState }> = (props) => (
    <Context.Provider value={props.value}>{props.children}</Context.Provider>
);

export { DeviceCountProvider, TestDeviceCountDataProvider, useDeviceCount };
